module.exports = __webpack_public_path__ + "static/media/logo-grey.1dab4490.svg";